export default __webpack_public_path__ + "static/media/18.2e095a94.png";